export function videoFrameToUnencodedVideoFrame(videoFrame, isScreenSharing = false, rotation = 0) {
    return {
        frameNumber: 0n,
        timestamp: BigInt(videoFrame.timestamp),
        duration: BigInt(videoFrame.duration ?? 0),
        trackId: '',
        done: false,
        isKeyFrame: false,
        codedWidth: videoFrame.displayWidth,
        codedHeight: videoFrame.displayHeight,
        isScreenSharing: isScreenSharing,
        rotation: rotation,
        videoFrame: videoFrame,
    };
}
export function closeVideoFrame(frame) {
    try {
        frame.videoFrame.close();
    }
    catch {
        console.warn('Failed to close VideoFrame, already closed or transferred?', frame);
    }
}
